function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "92.758%",
  y1: "-30.769%",
  x2: "11.763%",
  y2: "111.765%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#FAFAFB",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#F2F4F6",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "83.096%",
  y1: "-4.895%",
  x2: "29.326%",
  y2: "117.483%",
  id: "d"
}, React.createElement("stop", {
  stopColor: "#EFD001",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#EFA701",
  offset: "100%"
})), React.createElement("path", {
  d: "M61.77 142.83c18.499-8.14 35.368-21.833 50.607-41.079a48 48 0 0 0 10.367-29.796V25.852c-.35.003-.7.005-1.051.005-27.56 0-51.08-10.745-60.288-25.857-9.274 15.112-32.793 25.857-60.353 25.857-.352 0-.702-.002-1.052-.005v46.103a48 48 0 0 0 10.368 29.796c15.238 19.246 32.107 32.94 50.607 41.079l.384.17c.154-.057.282-.114.41-.17z",
  id: "c"
}), React.createElement("filter", {
  x: "-35.8%",
  y: "-24.5%",
  width: "171.7%",
  height: "161.5%",
  filterUnits: "objectBoundingBox",
  id: "b"
}, React.createElement("feOffset", {
  dy: 8,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 12,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.252634095 0 0 0 0 0.258173388 0 0 0 0 0.292517007 0 0 0 0.231855752 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feComposite", {
  in: "shadowBlurOuter2",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.137652853 0",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "url(#a)",
  cx: 111,
  cy: 111,
  r: 98
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(49 39)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#b)",
  xlinkHref: "#c"
}), React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 8,
  d: "M61.372 138.625c17.398-7.924 33.353-21.024 47.869-39.357a44 44 0 0 0 9.503-27.313V29.817C94.396 29.157 72.7 20.354 61.397 6.82 50.045 20.357 28.343 29.157 4 29.817v42.138a44 44 0 0 0 9.504 27.313c14.515 18.333 30.47 31.433 47.868 39.357z",
  strokeLinejoin: "square",
  fill: "url(#d)"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M101.945 120.484L128.43 94l3.515 3.516-30 30L88 113.57l3.516-3.515z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 221,
    height: 221,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2, React.createElement("circle", {
    fill: "url(#a)",
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.5,
    cx: 111.5,
    cy: 111.5,
    r: 107.5
  }), React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.52,
    style: {
      mixBlendMode: 'multiply'
    },
    cx: 111.5,
    cy: 111.5,
    r: 85.5
  }), React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.2,
    style: {
      mixBlendMode: 'multiply'
    },
    cx: 111,
    cy: 111,
    r: 70
  }), React.createElement("circle", {
    fill: "url(#a)",
    style: {
      mixBlendMode: 'multiply'
    },
    cx: 111,
    cy: 111,
    r: 50
  }), _ref3, _ref4));
};

export default __webpack_public_path__ + 'static/media/icon-security.4bec2895.svg';
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/images/icon-security.svg